<template>
    <LoadingStruct is-animation-disabled :is-loading="loadingInfos">
        <div
            :class="
                isEmbedded
                    ? isDisablePadding
                        ? ''
                        : 'uk-padding'
                    : 'uk-padding clickandbuy-struct'
            "
            :style="'background-color: ' + getColor">
            <div class="site-struct extended">
                <div class="uk-grid uk-grid-match uk-grid-divider" uk-grid>
                    <div class="uk-width-1-3@m uk-width-1-1" v-if="!isEmbedded">
                        <div class="logo-struct-clickandbuy uk-text-center">
                            <LinkObject
                                class="uk-link-reset"
                                :to="
                                    computedGetClickAndBuyRootLink +
                                    computedGetClickAndBuyQueryParam
                                ">
                                <img
                                    v-if="
                                        getInfos.clickAndBuy &&
                                        getInfos.clickAndBuy.logo
                                    "
                                    :src="
                                        apiUrl +
                                        '/clickandbuys/logos/' +
                                        getInfos.clickAndBuy.logo
                                    "
                                    class="clickandbuy-logo" />
                            </LinkObject>

                            <div
                                v-if="
                                    getInfos.clickAndBuy &&
                                    getInfos.clickAndBuy.company
                                "
                                class="clickandbuy-company">
                                <LinkObject
                                    class="uk-link-reset"
                                    :to="
                                        computedGetClickAndBuyRootLink +
                                        computedGetClickAndBuyQueryParam
                                    ">
                                    {{
                                        getInfos.clickAndBuy.company
                                    }}</LinkObject
                                >
                            </div>

                            <div class="clickandbuy-name">
                                <LinkObject
                                    v-if="getInfos.clickAndBuy"
                                    class="uk-link-reset"
                                    :to="
                                        computedGetClickAndBuyRootLink +
                                        computedGetClickAndBuyQueryParam
                                    ">
                                    {{ getInfos.clickAndBuy.name }}
                                </LinkObject>
                            </div>

                            <div
                                v-if="
                                    getInfos.clickAndBuy &&
                                    getInfos.clickAndBuy.title
                                "
                                class="clickandbuy-title">
                                <LinkObject
                                    class="uk-link-reset"
                                    :to="
                                        computedGetClickAndBuyRootLink +
                                        computedGetClickAndBuyQueryParam
                                    ">
                                    {{ getInfos.clickAndBuy.title }}</LinkObject
                                >
                            </div>

                            <div
                                class="uk-margin-top"
                                v-if="
                                    getInfos.clickAndBuy &&
                                    getInfos.clickAndBuy.links
                                ">
                                <div
                                    class="uk-child-width-1-6 uk-flex-center uk-grid-small"
                                    uk-grid>
                                    <div
                                        class="uk-width-auto"
                                        v-for="link in getInfos.clickAndBuy
                                            .links"
                                        :key="link">
                                        <a
                                            :href="getLink(link)"
                                            :target="
                                                getLink(link).includes('http')
                                                    ? '_blank'
                                                    : ''
                                            "
                                            class="uk-link-reset">
                                            <Icon :icon="getIcon(link)" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        :class="
                            isEmbedded
                                ? 'uk-width-1-1'
                                : 'uk-width-2-3@m uk-width-1-1'
                        ">
                        <slot />

                        <div v-if="!isEmbedded" class="footer">
                            <div class="uk-margin-medium-top">
                                <div
                                    uk-grid
                                    class="uk-grid-small uk-child-width-auto uk-flex-center uk-flex-middle">
                                    <div v-if="getInfos.footerText">
                                        {{ getInfos.footerText }}
                                    </div>

                                    <div>
                                        <ToggleItem
                                            is-dark
                                            toggle="target: #termsAndConditions">
                                            {{ $t('termsAndConditions') }}
                                        </ToggleItem>
                                        <Modal
                                            is-round
                                            id="termsAndConditions"
                                            :title="$t('termsAndConditions')"
                                            is-extended>
                                            <div
                                                v-html="
                                                    getInfos.termsAndConditions
                                                " />
                                        </Modal>
                                    </div>
                                    <div>
                                        <ToggleItem
                                            is-dark
                                            toggle="target: #dataPrivacy">
                                            {{ $t('dataPrivacy') }}
                                        </ToggleItem>
                                        <Modal
                                            id="dataPrivacy"
                                            :title="$t('dataPrivacy')"
                                            is-round
                                            is-extended>
                                            <div
                                                v-html="getInfos.dataPrivacy" />
                                        </Modal>
                                    </div>
                                    <div>
                                        <ToggleItem
                                            is-dark
                                            toggle="target: #siteNotice">
                                            {{ $t('siteNotice') }}
                                        </ToggleItem>
                                        <Modal
                                            is-round
                                            id="siteNotice"
                                            :title="$t('siteNotice')"
                                            is-extended>
                                            <div v-html="getInfos.siteNotice" />
                                        </Modal>
                                    </div>
                                    <div v-if="isCookieSettingsShown">
                                        <ToggleItem
                                            is-dark
                                            v-on:click.native="
                                                openCookieSettings()
                                            ">
                                            {{ $t('cookies.settings') }}
                                        </ToggleItem>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </LoadingStruct>
</template>

<script>
import Modal from '@/components/generic/Modal.vue';
import ToggleItem from '@/components/generic/ToggleItem.vue';
import axios from 'axios';
import LoadingStruct from '@/views/LoadingStruct.vue';
import Icon from '@/components/generic/Icon.vue';
import LinkObject from '@/components/LinkObject.vue';

export default {
    name: 'ClickAndBuysStruct',
    components: {
        LinkObject,
        Icon,
        LoadingStruct,
        ToggleItem,
        Modal,
    },
    computed: {
        isEmbedded() {
            const embedded = this.$route.query.embedded;
            return embedded === 'true';
        },
        isDisablePadding() {
            const embedded = this.$route.query.embedded;
            if (embedded !== 'true') {
                return false;
            }

            const disablepadding = this.$route.query.disablepadding;
            return disablepadding === 'true';
        },
        getColor() {
            if (this.remoteColor) {
                return this.remoteColor;
            }

            if (
                this.getInfos &&
                this.getInfos.clickAndBuy &&
                this.getInfos.clickAndBuy.color
            ) {
                return this.getInfos.clickAndBuy.color;
            }

            return '';
        },
    },
    data() {
        return {
            loadingInfos: true,

            remoteColor: null,
        };
    },
    methods: {
        formatToTelLink(str) {
            const cleaned = str.trim().replace(/\s+/g, '');

            if (/^\+?\d+$/.test(cleaned)) {
                return `tel:${cleaned}`;
            }

            return null;
        },
        isNumericPhoneNumber(str) {
            return /^\+?\d[\d\s]*$/.test(str.trim());
        },
        getLink(value) {
            const lowerValue = value.toLowerCase();

            if (!lowerValue.includes('http') && lowerValue.includes('@')) {
                return 'mailto:' + value;
            }

            if (
                !lowerValue.includes('http') &&
                this.isNumericPhoneNumber(value)
            ) {
                return this.formatToTelLink(value);
            }

            return value;
        },
        getIcon(value) {
            if (!value) {
                return 'social';
            }

            const icons = [
                '500px',
                'android',
                'android-robot',
                'apple',
                'behance',
                'bluesky',
                'discord',
                'dribbble',
                'etsy',
                'facebook',
                'flickr',
                'foursquare',
                'github',
                'github-alt',
                'gitter',
                'google',
                'instagram',
                'joomla',
                'linkedin',
                'mastodon',
                'microsoft',
                'pinterest',
                'reddit',
                'signal',
                'soundcloud',
                'telegram',
                'threads',
                'tiktok',
                'tripadvisor',
                'tumblr',
                'twitch',
                'uikit',
                'vimeo',
                'whatsapp',
                'wordpress',
                'x',
                'xing',
                'yelp',
                'yootheme',
                'youtube',
            ];

            const lowerValue = value.toLowerCase();

            for (const icon of icons) {
                if (!lowerValue.includes('http') && lowerValue.includes('@')) {
                    return 'mail';
                }

                if (
                    !lowerValue.includes('http') &&
                    this.isNumericPhoneNumber(value)
                ) {
                    return 'receiver';
                }

                if (
                    lowerValue.includes('http') &&
                    lowerValue.includes(icon.toLowerCase())
                ) {
                    return icon;
                }
            }

            return 'social';
        },
        receiveInfosLocale() {
            this.loadingInfos = true;

            const clickAndBuyID = this.$route.params.clickandbuy;
            let withclickandbuys = '';
            if (clickAndBuyID) {
                withclickandbuys = '?withclickandbuys=' + clickAndBuyID;
            }

            let http = axios.create();
            http.get(this.apiUrl + '/infos' + withclickandbuys)
                .then((response) => {
                    let data = response.data;

                    document.title = data.clickAndBuy.name;

                    if (!data.clickAndBuy) {
                        this.routeTo('');
                        return;
                    }

                    this.$store.state.infos = data;

                    document.documentElement.style.setProperty(
                        'background-color',
                        data.clickAndBuy.color,
                        'important'
                    );
                    document.body.style.setProperty(
                        'background-color',
                        data.clickAndBuy.color,
                        'important'
                    );

                    this.loadingInfos = false;
                })
                .catch((e) => {
                    this.checkGenericError(e);
                    this.loadingInfos = false;
                });
        },
        initRemoteScript() {
            const embedded = this.$route.query.embedded;
            if (embedded !== 'true') {
                return false;
            }

            const remote = this.$route.query.remote;
            if (remote !== 'true') {
                return false;
            }

            const sendHeight = () => {
                const height = document.body.scrollHeight;
                parent.postMessage({embeddedHeight: height}, '*');
            };
            addEventListener('load', sendHeight);
            addEventListener('resize', sendHeight);
            new ResizeObserver(sendHeight).observe(document.body);

            addEventListener('message', (e) => {
                if (e.data?.action === 'setBackgroundColor' && e.data.color) {
                    this.remoteColor = e.data.color;
                }
            });

            parent.postMessage({status: 'ready'}, '*');
        },
    },
    created() {
        this.receiveInfosLocale();
    },
    mounted() {
        document.documentElement.style.overflowX = 'visible';
        document.body.style.overflowX = 'visible';

        this.initRemoteScript();
    },
};
</script>

<style lang="scss" scoped>
.clickandbuy-logo {
    max-width: 180px;
    max-height: 180px;
    border-radius: $border-radius-next;
    margin-bottom: 20px;
}

.clickandbuy-name {
    font-size: 24px;
    font-weight: 500;
    color: $site-background;
}

.clickandbuy-struct {
    padding-top: 60px;
    color: $site-background;
}

@media (min-width: 960px) {
    .logo-struct-clickandbuy {
        min-height: calc(100vh - 60px);
        margin-top: -60px;
        padding-top: calc(50vh - 141px);
        position: sticky;
        top: 0;
        height: 42px;
    }
}

.footer {
    color: $site-background;
}

.clickandbuy-title {
    font-size: 18px;
    font-weight: 400;
    margin-top: 20px;
    color: $site-background;
}

.clickandbuy-company {
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 5px;
    color: $site-background;
}
</style>
